import "./styles.scss";

import React, { useState, useEffect, useContext, Fragment, useCallback, useMemo } from "react";
import { withRouter, useParams } from "react-router-dom";

import { Button } from "react-bootstrap";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import { PACreateContext } from "../../Contexts/PAContext";

import CreateNewRules from "./Components/CreateNewRules";
import { getGroupsRules, editGroupsRules } from "../../../../../services/NexiDigitalAPI";

const VALIDATION_ERRORS = {
  ATTRIBUTE_REQUIRED: 'erroAttribute',
  PERIOD_TYPE_REQUIRED: 'erroPeriodType',
  RELATIVE_PERIOD_REQUIRED: 'errorRelativePeriod',
  CUSTOM_PERIOD_REQUIRED: 'erroCustomPeriod',
  ERROR_FROM_VALUE: 'errorFromValue',
  ERROR_FROM_TYPE: 'errorFromType',
  ERROR_TO_VALUE: 'errorToValue',
  ERROR_TO_TYPE: 'errorToType',
  ABSOLUTE_PERIOD_REQUIRED: 'erroCustomAbsolute',
  VALUE_REQUIRED: 'erroValue'
};

const METHODS = {
  RELATIVE: 'RELATIVE',
  ABSOLUTE: 'ABSOLUTE',
  CONTAINS: 'CONTAINS'
};

const PERIOD_TYPES = {
  TODAY: 'today',
  PAST_DAYS: 'pastDays',
  FUTURE_DAYS: 'futureDays',
  CUSTOM: 'custom'
};

const GroupsRules = (props) => {
  const [rulesEdit, setRulesEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);

  const {
    containerRules,
    setContainerRules,
    setPreloadInit,
    openConfirmModal
  } = useContext(PACreateContext);

  const { groupId, groupTitle } = useParams();

  const navigationPath = useMemo(() =>
    `/configuracao/grupos/editar/${groupId}/${groupTitle}/`,
    [groupId, groupTitle]
  );

  const returnEditar = useCallback(() => {
    props.history.push(navigationPath);
  }, [props.history, navigationPath]);

  const callClosed = useCallback(() => {
    openConfirmModal({
      title: "Você tem certeza de que deseja sair sem salvar?",
      text: "Caso você confirme a saída agora, todas as suas alterações de regra serão perdidas. Por favor, confirme sua escolha antes de prosseguir.",
      variantBtn: "warning",
      textBtn: "Sair e não salvar",
      fnc: returnEditar,
    });
  }, [openConfirmModal, returnEditar]);

  const createRules = useCallback(() => {
    const newRules = {
      idGroups: groupId,
      items: [{ method: METHODS.CONTAINS }],
    };
    setContainerRules(prev => [...(prev || []), newRules]);
  }, [groupId, setContainerRules]);

  const validateAttribute = (item) => {
    if (!item.attribute) {
      item[VALIDATION_ERRORS.ATTRIBUTE_REQUIRED] = true;
      return false;
    }
    item[VALIDATION_ERRORS.ATTRIBUTE_REQUIRED] = false;
    return true;
  };

  const validatePeriodType = (item) => {
    if (item.method === METHODS.RELATIVE && !item.periodType) {
      item[VALIDATION_ERRORS.PERIOD_TYPE_REQUIRED] = true;
      return false;
    }
    item[VALIDATION_ERRORS.PERIOD_TYPE_REQUIRED] = false;
    return true;
  };

  const validateRelativePeriod = (item) => {
    // Limpar todos os erros relacionados ao período
    item[VALIDATION_ERRORS.CUSTOM_PERIOD_REQUIRED] = false;
    item[VALIDATION_ERRORS.ERROR_FROM_VALUE] = false;
    item[VALIDATION_ERRORS.ERROR_FROM_TYPE] = false;
    item[VALIDATION_ERRORS.ERROR_TO_VALUE] = false;
    item[VALIDATION_ERRORS.ERROR_TO_TYPE] = false;
    item[VALIDATION_ERRORS.VALUE_REQUIRED] = false;
    item[VALIDATION_ERRORS.RELATIVE_PERIOD_REQUIRED] = false;

    switch (item.periodType) {
      case PERIOD_TYPES.TODAY:
        item.start = 0;
        item.end = 0;
        return true;

      case PERIOD_TYPES.PAST_DAYS:
        if (item.start !== undefined && item.start !== "") {
          item.start = -Math.abs(Number(item.start));
          item.end = 0;
          return true;
        }
        item[VALIDATION_ERRORS.RELATIVE_PERIOD_REQUIRED] = true;
        return false;

      case PERIOD_TYPES.FUTURE_DAYS:
        if (item.end !== undefined && item.end !== "") {
          item.start = 0;
          item.end = Math.abs(Number(item.end));
          return true;
        }
        item[VALIDATION_ERRORS.RELATIVE_PERIOD_REQUIRED] = true;
        return false;

      case PERIOD_TYPES.CUSTOM:
        let isValid = true;

        // Validar campo "De" (valor)
        if (!item.start || item.start === "") {
          item[VALIDATION_ERRORS.ERROR_FROM_VALUE] = true;
          isValid = false;
        }

        // Validar campo "De" (tipo)
        if (!item.periodCustomFromType) {
          item[VALIDATION_ERRORS.ERROR_FROM_TYPE] = true;
          isValid = false;
        }

        // Validar campo "Até" (valor)
        if (!item.end || item.end === "") {
          item[VALIDATION_ERRORS.ERROR_TO_VALUE] = true;
          isValid = false;
        }

        // Validar campo "Até" (tipo)
        if (!item.periodCustomToType) {
          item[VALIDATION_ERRORS.ERROR_TO_TYPE] = true;
          isValid = false;
        }

        if (isValid) {
          item.start = item.periodCustomFromType === PERIOD_TYPES.PAST_DAYS
            ? -Math.abs(Number(item.start))
            : Math.abs(Number(item.start));
          item.end = item.periodCustomToType === PERIOD_TYPES.FUTURE_DAYS
            ? Math.abs(Number(item.end))
            : -Math.abs(Number(item.end));
        }

        return isValid;

      default:
        item[VALIDATION_ERRORS.RELATIVE_PERIOD_REQUIRED] = true;
        return false;
    }
  };

  const validateAbsolutePeriod = (item) => {
    if (item.dateAbsolute?.start && item.dateAbsolute?.end) {
      item[VALIDATION_ERRORS.ABSOLUTE_PERIOD_REQUIRED] = false;
      item[VALIDATION_ERRORS.VALUE_REQUIRED] = false;
      item.value = [{
        start: item.dateAbsolute.start,
        end: item.dateAbsolute.end,
      }];
      return true;
    }

    item[VALIDATION_ERRORS.ABSOLUTE_PERIOD_REQUIRED] = true;
    item[VALIDATION_ERRORS.VALUE_REQUIRED] = true;
    return false;
  };

  const validateGeneralValue = (item) => {
    if (!item.value || item.value.length === 0) {
      item[VALIDATION_ERRORS.VALUE_REQUIRED] = true;

      return false;
    }
     item.value =item.value.map(item => item.title || item)
    item[VALIDATION_ERRORS.VALUE_REQUIRED] = false;
    return true;
  };

  const validateItem = (item) => {
    let isValid = true;

    if (!validateAttribute(item)) {
      isValid = false;
    }

    if (item.attribute === "dataAdmissao") {
      if (!validatePeriodType(item)) {
        isValid = false;
      }
      if (item.method === METHODS.RELATIVE) {
        if (validateRelativePeriod(item)) {
          item.value = [{ start: item.start, end: item.end }];
        } else {
          isValid = false;
        }
      } else if (item.method === METHODS.ABSOLUTE) {
        if (!validateAbsolutePeriod(item)) {
          isValid = false;
        }
      }

    } else {
      if (!validateGeneralValue(item)) {
        isValid = false;
      }
    }

    return isValid;
  };

 const validateSave = useCallback(() => {
  let hasErrors = false;

  const validatedRules = containerRules.map((rule) => ({
    ...rule,
    items: rule.items.map((item) => {
      const itemCopy = { ...item };
      if (!validateItem(itemCopy)) {
        hasErrors = true;
      }
      return itemCopy;
    }),
  }));

  setContainerRules(validatedRules);

  if (!hasErrors) {
    if (rulesEdit) {
      modalSave(validatedRules);
    } else {
      saveApi(validatedRules);
    }
  }
}, [containerRules, rulesEdit, setContainerRules]);

const saveApi = useCallback(async (rulesToSave) => {
  try {
    setIsLoading(true);
    setPreloadInit(true);
    await editGroupsRules(groupId, rulesToSave);
    returnEditar();
  } catch (error) {
    console.error('Erro ao salvar regras:', error);
  } finally {
    setIsLoading(false);
    setPreloadInit(false);
  }
}, [groupId, returnEditar, setPreloadInit]);

const modalSave = useCallback(
  (rulesToSave) => {
    openConfirmModal({
      text: "Alerta <b>IMPORTANTE</b>, quaisquer alterações nas regras resultarão em modificações nas matrículas ao serem salvas. Tem certeza de que deseja prosseguir?",
      variantBtn: "warning",
      textBtn: "Prosseguir e alterar regras",
      fnc: () => saveApi(rulesToSave), // <-- chama com closure
    });
  },
  [openConfirmModal, saveApi]
);

  useEffect(() => {
    let isMounted = true;

    const fetchRules = async () => {
      if (hasInitialized) return;

      try {
        setPreloadInit(true);
        const response = await getGroupsRules(groupId);

        if (isMounted) {
          setContainerRules(response.data);
          setRulesEdit(response.data.length > 0);
          setHasInitialized(true);
        }
      } catch (error) {
        console.error('Erro ao buscar regras:', error);
      } finally {
        if (isMounted) {
          setPreloadInit(false);
        }
      }
    };

    fetchRules();

    return () => {
      isMounted = false;
    };
  }, [groupId, hasInitialized]);

  useEffect(() => {
    const element = document.querySelector(".route-section-content");

    if (element) {
      element.style.overflowY = "hidden";
    }

    return () => {
      if (element) {
        element.style.overflowY = "auto";
      }
    };
  }, []);

  const renderActionButtons = () => (
    <div className="footerBtns">
      <Button variant="outline-secondary" onClick={callClosed} disabled={isLoading}>
        Fechar
      </Button>
      <Button variant="warning" onClick={validateSave} disabled={isLoading}>
        {isLoading ? 'Salvando...' : 'Salvar'}
      </Button>
    </div>
  );

  const renderRulesList = () => {
    if (!containerRules || containerRules.length === 0) {
      return <div className="notRules">Nenhuma regra foi criada.</div>;
    }

    return containerRules.map((item, indice) => (
      <Fragment key={`${item.idGroups}_${indice}`}>
        <CreateNewRules rule={item} indice={indice + 1} />
      </Fragment>
    ));
  };

  return (
    <div className="PACreateRules" id="blockRules">
      <div className="PACreateRulesBase">
        <div className="PA-header-title-wrapper">
          <div className="PA-header-title">
            <button className="btnGoBack" onClick={callClosed}>
              <KeyboardArrowLeftIcon style={{ fontSize: 40 }} />
            </button>
            Cadastro de usuário / … / Editar público-alvo / <b>Editar regra do público-alvo</b>
          </div>
        </div>

        <div className="infoRules">
          <div className="infoRulesText">
            <h1>Inserir público-alvo por regra</h1>
            <p>
              Você pode inserir regras com campos de perfis para definir seu público-alvo. Escolha
              as condições que acionam as regras para o seu público-alvo.
            </p>
          </div>
          <Button variant="primary" onClick={createRules} disabled={isLoading}>
            + Adicionar nova regra
          </Button>
        </div>

        <div className="listRules">
          {renderRulesList()}
        </div>

        {renderActionButtons()}
      </div>
    </div>
  );
};

export default withRouter(GroupsRules);
